/**
 * Factory logins see Home and Forecast only. The API enforces the same limit (api/src/middleware/auth.ts
 * factoryScope); this keeps the menu and links from offering pages they can't open.
 */
export const FACTORY_PAGES = new Set(["/", "/forecast", "/password"]);
